import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const GlobalBookingListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOpenBooking = (e: Event) => {
      const customEvent = e as CustomEvent;
      const view = customEvent.detail?.view || 'custom-plan';
      navigate(`/book?view=${view}`);
    };

    document.addEventListener("open-booking", handleOpenBooking);
    return () => document.removeEventListener("open-booking", handleOpenBooking);
  }, [navigate]);

  return null;
};
